import React from 'react';

import HomeIcon from '@material-ui/icons/Home';
import NotificationIcon from '@material-ui/icons/NotificationsActive';
import SettingsIcon from '@material-ui/icons/Settings';
import UsersIcon from '@material-ui/icons/People';
import MemberShipIcon from '@material-ui/icons/Storage';
import CreditRequestIcon from '@material-ui/icons/CreditCard';
import AuditIcon from '@material-ui/icons/VerifiedUser';

export const IconsList = {
  homeIcon: HomeIcon,
  settingsIcon: SettingsIcon,
  usersIcon: UsersIcon,
  notificationIcon: NotificationIcon,
  memberShipIcon: MemberShipIcon,
  creditRequestIcon: CreditRequestIcon,
  auditIcon: AuditIcon,
};

function renderer(item) {
  if (typeof IconsList[item.icon] !== 'undefined') {
    return React.createElement(IconsList[item.icon]);
  }
}

export default renderer;
